<template>
  <div class="Contact" style="position:fixed">
      <b-container fluid style="padding-top: 100px; ">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">

                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>Complaint Status</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>

        <b-row>

          <b-col col cols="12" sm="12" md="12" lg="12" style="height:75vh; overflow-y:scroll;;">
            <div id="kofficial">
              <b-row>
                <b-col cols="12">
                    <h1 class="heading">Complaint Status</h1>
                </b-col>
              </b-row>
             <p class="content">
                <b-table style= "text-align:left" responsive bordered striped  :items="getComplaintStatus" :fields="ComplaintStatusfields"></b-table>
              </p>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <br><br>
  </div>
</template>

<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import { mapGetters, mapActions } from 'vuex'
var thColor = '#0288d1';
export default {
  name: 'ComplaintStatus',
  components: {

      'HeaderFixed' : HeaderFixed,
      'HeaderMobile' : HeaderMobile
    },
    data() {
        return {
        ComplaintStatusfields: [
            { key: 'sl_no', label: 'Sl/No',thStyle: {width: '5vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'date', label: 'Date',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'comp_type', label: 'Complaint Type',thStyle: {width: '15vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'comp_desc', label: 'Complaint Description',thStyle: {width: '25vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'comp_src', label: 'Complaint Source',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'action', label: 'Action Taken',thStyle: {width: '15vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'resolved_date', label: 'Resolved Date',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'feedback', label: 'Feedback',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
          ],
        }
      },
      computed:
      {
        ...mapGetters([
          'getComplaintStatus',
          ])

      },
      methods: {
        ...mapActions([
          'retrieveComplaintStatus'
        ]),
      },
        beforeMount() {
            if(this.getComplaintStatus.length == 0) {
              this.retrieveComplaintStatus()
            }
        }
}


</script>

<style scoped="true">
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;
}
.content{
  text-align: justify;
  line-height: 1.8rem;
  font-size: 0.9rem;
}
.cntnt{
  box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
  padding:10px 30px 10px 30px;
}

#vision{
  transition: 1s;
}
table{
  text-align: left !important;
}

@media (max-width: 768px) {
  .cntnt{
    box-shadow: none;
    padding:10px 30px 10px 30px;
  }
  }
    li{
      padding:0;
    }

    body{
      overflow-y:hidden;
    }
    .headerF{
      display: block;
    }
    .headerM{
      display: none;
    }
    .sideNav{
      height:75vh;
      overflow-y:hidden;
    }
    .dropdownmenu{
      display: none;
    }
    @media (max-width: 768px) {
        .headerF{
          display: none;
        }
        .headerM{
          display: block;
        }
        .sideNav{
          /* height:50vh;
          overflow-y:hidden; */
          display: none
        }
        .dropdownmenu{
          display: block;
        }
      }
      @media (max-width: 576px) {
        .sideNav{
          /* height:50vh;
          overflow-y:hidden; */
          display: none
        }
        .dropdownmenu{
          display: block;
        }
      }
</style>
